<template>
  <button
    :class="{
      [$style.button]: true,
      [$style.disabled]: disabled,
    }"
    :disabled="disabled"
    @click.stop="disabled ? null : $emit('click')"
  >
    <div v-if="text">
      <p :class="$style['button-text']">
        {{ text }}
      </p>
    </div>
    <div v-else :class="[$style['button-text']]">
      <slot />
    </div>
  </button>
</template>

<script>
export default {
  emits: ['click'],
  props: {
    disabled: { type: Boolean, default: false },
    text: String,
  },
};
</script>

<style lang="less" module>
.button {
  border: none;
  background: @color-black;
  color: @color-white;
  cursor: pointer;
  display: inline-block;
  font-family: @regular-font;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  height: 50px;
  padding: 0 @gutter-30;
  transition: all 200ms ease;

  .button-text {
    display: inline-block;
    line-height: 0.8;
    margin: auto 0;
    position: relative;
    top: 1px;
  }

  &.disabled {
    background-color: @color-lightgray-500;
    cursor: default;
  }

  &:hover:not(.disabled) {
    background: @color-purple;
  }

  &:focus {
    box-shadow: 0 0 0 2px @color-blue-focus;
  }
}
</style>
